// extracted by mini-css-extract-plugin
export default {"home":"Home_home__4F169","item":"Home_item__xTeTL"};